import { Separator, Skeleton } from "@/components/ui";
import { Fragment } from "react";

export const HealthMaintenanceScreeningsSkeleton = ({
  rowCount,
}: { rowCount: number }) => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors mt-1 pt-1"
      data-testid="health-maintenance-skeleton"
    >
      {[...Array(rowCount)].map((_, index) => (
        //  biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
        <Fragment key={`health-maintenance-skeleton-${index}`}>
          <div className="flex flex-row gap-2">
            <Skeleton className="h-4 w-[30%]" />
            <Skeleton className="h-4 w-[15%]" />
            <Skeleton className="h-4 w-[25%]" />
            <Skeleton className="h-4 w-[30%]" />
          </div>
          <Separator />
        </Fragment>
      ))}
    </div>
  );
};

export const HealthMaintenanceSocialSkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors mt-1 py-1"
      data-testid="health-maintenance-skeleton"
    >
      {[...Array(3)].map((_, index) => (
        //  biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
        <Fragment key={`health-maintenance-skeleton-${index}`}>
          <div className="flex flex-row gap-2">
            <Skeleton className="h-10 w-full" />
          </div>
          <Separator />
        </Fragment>
      ))}
    </div>
  );
};
